import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 700
  },
  selectOrDeselectAllButton: {
    marginTop: 'unset'
  }
})

export default useStyles
